import React, { useEffect } from 'react';
import Helmet from 'react-helmet';

import Section from '@latitude/section';
import Layout from '@/components/layout';
import AchPageHeaderSection from './_ach-page-header';

function AchLoginPage(props) {
  useEffect(() => {
        if (window?.location){
          window.location.replace('https://latitudefs.zendesk.com/hc/en-au/articles/36591875170577-Additional-Cardholders')
        }
      },[])
  return (
    <Layout location={props.location}>
      <main className="navigation-spacer">
        <Helmet>
          <link
            rel="canonical"
            href="https://www.latitudefinancial.com.au/credit-cards/gomastercard/additional-cardholder/login/"
          />
          <meta
            name="description"
            content="Add an additional cardholder to your Latitude GO Mastercard"
          />
          <title>Additional Card Holder Login | GO Mastercard</title>
        </Helmet>

        <AchPageHeaderSection />
        <Section>
          <div
            css={{ clear: 'both', margin: '10px 0' }}
            className="lfs-iframe-vixverify"
          >
            <iframe
              css={{
                width: '100%',
                height: '400px',
                border: 'none',
                padding: '10px'
              }}
              title="Verify Your Identity"
              src="https://au.vixverify.com/sa/customers/gecapital-ach/login.seam?ui=go"
            />
          </div>
        </Section>
      </main>
    </Layout>
  );
}

export default AchLoginPage;
